import { render, staticRenderFns } from "./insert-compra.vue?vue&type=template&id=0da1cdd8&scoped=true&"
import script from "./insert-compra.vue?vue&type=script&lang=js&"
export * from "./insert-compra.vue?vue&type=script&lang=js&"
import style0 from "./insert-compra.vue?vue&type=style&index=0&id=0da1cdd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da1cdd8",
  null
  
)

export default component.exports